import { Component, OnInit, Type } from '@angular/core';
import { ModalService } from '../../shared/modal.service';
import { cloneDeep } from 'lodash';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { FeedbackRequestType } from '../../shared/types/feedback-request-type';
import { TeacherFeedBackStatus } from '../../shared/types/teacher-feedback-status-type';
import {
  AskATeacherFeedbackModalComponent,
  AskATeacherFeedbackModalData,
} from '../ask-a-teacher-feedback-modal/ask-a-teacher-feedback-modal.component';
import { feedbacksAnimationTrigger, slideIn } from '../teacher-feedback-animations';
import { LegacyTeacherFeedbackService } from '../teacher-feedback-service/legacy-teacher-feedback.service';
import { TeacherFeedbackDto } from '../teacher-feedback-service/teacher-feedback-dto';
import {
  TeacherLiveClassFeedbackData,
  TeacherLiveClassFeedbackModalComponent,
} from '../teacher-liveclass-feedback-modal/teacher-liveclass-feedback-modal.component';
import { TeacherFeedbackModalComponent } from '../teacher-feedback-modal/teacher-feedback-modal.component';
import { formatTeacherResponseText } from '../../shared/utils/text-utils';

const FEEDBACK_COMPONENT_MAP: { [key in FeedbackRequestType]?: Type<any> } = {
  [FeedbackRequestType.LIVE_CLASS_FEEDBACK]: TeacherLiveClassFeedbackModalComponent,
  [FeedbackRequestType.ASK_A_TEACHER]: AskATeacherFeedbackModalComponent,
  [FeedbackRequestType.WRITING_FEEDBACK]: AskATeacherFeedbackModalComponent,
  [FeedbackRequestType.LEVEL_TEST_FEEDBACK]: TeacherFeedbackModalComponent,
  [FeedbackRequestType.MID_LEVEL_TEST_FEEDBACK]: TeacherFeedbackModalComponent,
};

@Component({
  selector: 'lp2-teacher-feedback-collection',
  templateUrl: './teacher-feedback-collection.component.html',
  styleUrls: ['./teacher-feedback-collection.component.scss'],
  animations: [feedbacksAnimationTrigger, slideIn],
})
export class TeacherFeedbackCollectionComponent implements OnInit {
  page = 1;
  pageSize = 5;
  totalPages = 1;
  isLoadingFeedback = false;
  feedbackCollection: TeacherFeedbackDto[];
  detailFeedbackInModal: TeacherFeedbackDto = null;
  animateLoadedFeedbacks = 0;
  liveClassEnabled: boolean;

  constructor(
    private legacyTeacherFeedbackService: LegacyTeacherFeedbackService,
    private modalService: ModalService,
    private oeAppPerson: OeAppPersonService
  ) {
    this.getTeacherFeedbackFromService();
  }

  ngOnInit(): void {
    this.liveClassEnabled = this.oeAppPerson.liveClassEnabled;
  }

  getTeacherFeedbackFromService() {
    this.feedbackCollection = [];
    this.isLoadingFeedback = true;
    this.legacyTeacherFeedbackService.getTeacherFeedback(this.page, this.pageSize).subscribe((response) => {
      const feedbackList = response.feedbackRequests.filter((item) => {
        if (item.requestType === FeedbackRequestType.LIVE_CLASS_FEEDBACK) {
          return item.status === TeacherFeedBackStatus.COMPLETE;
        }
        return true;
      });
      this.feedbackCollection = feedbackList;
      this.totalPages = response.pages;
      this.isLoadingFeedback = false;
      this.animateLoadedFeedbacks = this.animateLoadedFeedbacks + 1;
    });
  }

  goToPreviousPage() {
    if (this.page <= 1) {
      return;
    }
    this.page = this.page - 1;
    this.getTeacherFeedbackFromService();
  }

  goToNextPage() {
    if (this.page >= this.totalPages) {
      return;
    }
    this.page = this.page + 1;
    this.getTeacherFeedbackFromService();
  }

  private setReadDateAndRefreshList(feedbackItem: TeacherFeedbackDto) {
    this.legacyTeacherFeedbackService.postViewedFeedback(feedbackItem.response.id).subscribe(() => {
      feedbackItem.response.viewed = new Date().valueOf();
      this.feedbackCollection = cloneDeep(this.feedbackCollection);
    });
  }

  openTeacherFeedbackDetailModal(feedbackItem: TeacherFeedbackDto) {
    if (feedbackItem.requestType === FeedbackRequestType.ASK_A_TEACHER) {
      feedbackItem.response.text = formatTeacherResponseText(feedbackItem.response.text);
    }

    let component = FEEDBACK_COMPONENT_MAP[feedbackItem.requestType] || TeacherLiveClassFeedbackModalComponent;
    let data: TeacherLiveClassFeedbackData | AskATeacherFeedbackModalData;

    switch (feedbackItem.requestType) {
      case FeedbackRequestType.LIVE_CLASS_FEEDBACK: {
        data = {
          feedbackResponseId: feedbackItem.response.id,
          title: feedbackItem.text,
          viewed: feedbackItem.response.viewed,
          isFromProgressPage: true,
        };
        break;
      }
      case FeedbackRequestType.WRITING_FEEDBACK:
      case FeedbackRequestType.ASK_A_TEACHER: {
        data = {
          feedback: feedbackItem,
        };
        break;
      }
      default: {
        data = {
          feedback: feedbackItem,
        };
        break;
      }
    }
    this.modalService.openModalWithInjectData(component, data);
    if (component !== TeacherFeedbackModalComponent) {
      this.setReadDateAndRefreshList(feedbackItem);
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/teacher-feedback-collection/teacher-feedback-collection.component.ts